<div class="contains-button">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <div class="item" style="margin-bottom: 12%;">
        <!-- Upload input -->
        <input
          type="file"
          (change)="onUpload($event)"
          id="upload"
          style="display: none"
        />
        <nz-radio-group class="w-100" [(ngModel)]="config.isImageSaved">
          <label nz-radio [nzValue]="true" for="upload" class="radio-option-1">
            <button
              (click)="openUpload()"
              [disabled]="!config.isImageSaved"
              [ngClass]="{ disable: !config.isImageSaved }"
              class="upload-background-image"
              (change)="onUpload($event)"
            >
              <span><i class="bi bi-plus-circle"></i>Chọn ảnh từ thư viện</span>
            </button>
          </label>
          <!-- Using image path -->
          <label nz-radio [nzValue]="false" class="radio-option-2" >
              <mat-form-field appearance="fill" class="text-field">
                <mat-label>{{'su_dung_duong_dan_hinh_anh' | translate}}</mat-label>
                <input
                  class="text"
                  type="text"
                  placeholder="Nhập đường dẫn"
                  [disabled]="config.isImageSaved"
                  matInput
                  [(ngModel)]="staticdata.img"
                  (ngModelChange)="updateObject()"
                  (blur)="updateObject()"
                />
              </mat-form-field>
          </label>
        </nz-radio-group>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li
        nz-submenu
        nzTitle="Hình ảnh"
        [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')"
      >
        <div class="item" style="margin-bottom: 12%;">
          <!-- Upload input -->
          <input
            type="file"
            (change)="onUpload($event)"
            id="upload"
            style="display: none"
          />
          <nz-radio-group class="w-100" [(ngModel)]="config.isImageSaved">
            <label nz-radio [nzValue]="true" for="upload" class="radio-option-1">
              <button
                (click)="openUpload()"
                [disabled]="!config.isImageSaved"
                [ngClass]="{ disable: !config.isImageSaved }"
                class="upload-background-image"
                (change)="onUpload($event)"
              >
                <span><i class="bi bi-plus-circle"></i>Chọn ảnh từ thư viện</span>
              </button>
            </label>
            <!-- Using image path -->
            <label nz-radio [nzValue]="false" class="radio-option-2" >
                <mat-form-field appearance="fill" class="text-field">
                  <mat-label>{{'su_dung_duong_dan_hinh_anh' | translate}}</mat-label>
                  <input
                    class="text"
                    type="text"
                    placeholder="Nhập đường dẫn"
                    [disabled]="config.isImageSaved"
                    matInput
                    [(ngModel)]="staticdata.img"
                    (ngModelChange)="updateObject()"
                    (blur)="updateObject()"
                  />
                </mat-form-field>
            </label>
          </nz-radio-group>
        </div>
      </li>
      <li
        nz-submenu
        nzTitle="Chọn popup hiển thị"
        [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')"
      >
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Chọn khối hiển thị"
          [(ngModel)]="staticdata.id_freeblock"
          (ngModelChange)="updateObject()"
        >
          <nz-option
            *ngFor="let block of blockList"
            [nzLabel]="block.name"
            [nzValue]="block._id"
          ></nz-option>
        </nz-select>
      </li>
      <li
        nz-submenu
        nzTitle="Chọn hướng popup hiển thị"
        [(nzOpen)]="openMap.menu3"
        (nzOpenChange)="openHandler('menu3')"
      >
        <div>
          <nz-radio-group
            [(ngModel)]="objectChoosing.direction"
            (ngModelChange)="handleChangeDirection($event);updateObject()"
          >
            <label nz-radio nzValue="left">Trái</label>
            <label nz-radio nzValue="right">Phải</label>
            <label nz-radio nzValue="top">Trên</label>
            <label nz-radio nzValue="bottom">Dưới</label>
          </nz-radio-group>
        </div>
      </li>
    </ul>
  </ng-container>
</div>
